import { render, staticRenderFns } from "./WorkShiftClosing.vue?vue&type=template&id=1d52ef08&scoped=true&"
import script from "./WorkShiftClosing.vue?vue&type=script&lang=js&"
export * from "./WorkShiftClosing.vue?vue&type=script&lang=js&"
import style0 from "./WorkShiftClosing.vue?vue&type=style&index=0&id=1d52ef08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d52ef08",
  null
  
)

export default component.exports